import { escapeHtml } from 'sma.common/utils.js';

const selectTempl = require('sma.admin/components/dropdowns/partials/dropselect.mustache');
const itemsTempl = require('sma.admin/components/dropdowns/partials/items.mustache');
const groupTempl = require('sma.admin/components/dropdowns/partials/group.mustache');
const itemActionsTempl = require('sma.admin/components/dropdowns/partials/actionpopover.mustache');
const wrapsTempl = require('sma.admin/components/dropdowns/partials/popover_wrapper.html');

/* pass in items as a list of objects like this:
 * {
 *	   name: 'foo',
 *	   text: 'foobar',
 *	   checked: true,
 *	   ignoreItemActions: false
 * }
 * onDone is a callback that is passed the item list in the same format as above */

class DropSelect extends Backbone.View {
	get events() {
		this.$el = $(this.el);
		return {
			'click .sma-js-dropselect-done': 'handleDone',
			'click .sma-js-dropselect-cancel': 'handleCancel',
			'click .sma-js-dropselect-editable-itemactions': 'bindItemActions',
			'click .custom-control-input': 'selectMixedCheckbox',
			'click .sma-js-action-item': 'selectItem',
			'click .sma-js-dropselect-select-all': 'selectAll',
			'click .sma-js-dropselect-select-none': 'selectNone',
			'change .dropdown-item input[type="checkbox"]': 'itemChanged',
			'hide.bs.dropdown': 'hideDropdown',
			'shown.bs.dropdown': 'getItems',
		};
	}

	initialize(options) {
		$(document).on('click', '.sma-dropselect, .sma-dropselect .dropdown-item', e => e.stopPropagation());

		if (_.has(options, 'itemNameFromSelectBox'))
			this.itemNameFromSelectBox = options.itemNameFromSelectBox;

		this.handleSelectElement(options);

		this.loading = false;

		//pass in this for access to an extra object (ie. grid)
		this.additionalScope = options.additionalScope || null;

		this.buttonSize = options.buttonSize || 'btn-md';
		this.textStyleButton = options.textStyleButton || false;
		this.btnClass = options.btnClass || 'btn-default';

		this.itemActions = options.itemActions || null;

		this.inline = options.inline || null;

		this.closeOnItemSelect = options.closeOnItemSelect || false;
		this.popoverPlacement = options.popoverPlacement || 'right';

		this.populateItemsFromDatasource = options.populateItemsFromDatasource || false;
		this.itemsFromDatasource = options.itemsFromDatasource;

		this.checkboxItems = 'checkboxItems' in options ? options.checkboxItems : true;

		if (_.has(options, 'selectedCount'))
			this.selectedCount = options.checkboxItems;

		if (_.has(options, 'noDropdown'))
			this.noDropdown = options.noDropdown;

		if (_.has(options, 'createButtonLabel'))
			this.createButtonLabel = options.createButtonLabel;

		if (_.has(options, 'noDoneButton'))
			this.noDoneButton = options.noDoneButton;

		if (_.has(options, 'singleSelect'))
			this.singleSelect = options.singleSelect;

		if (_.has(options, 'selector'))
			this.selector = options.selector;

		if (_.has(options, 'minimumSelected'))
			this.minimumSelected = options.minimumSelected;

		this.setItems(options.items);

		this.onDone = options.onDone || function () { return; };
		this.alignRight = options.alignRight || false;

		this.fullWidth = options.fullWidth || false;
		this.dropup = options.dropup || false;

		this.doneClass = 'sma-js-dropselect-done';
		this.cancelClass = 'sma-js-dropselect-cancel';

		this.title = options.title;
		this.dropdownToggle = options.dropdownToggle || false;

		this.filtering = null;

		this.disabledItems = {};

		this.render();

		this.onSelectChange = options.onSelectChange;
		if (this.$selectEl) {
			this.$selectEl.after(this.$el);
		}
	}

	filterValues(values) {
		this.filtering = values;

		this.renderItems();
		this.updateSelectControls();
	}

	itemNameFromSelectBox($item) {
		return $item.val();
	}

	populateFromSelectBox(options) {
		this.$selectEl.hide();

		if (this.$selectEl.attr('multiple')) {
			this.singleSelect = false;
		}

		let $options = this.$selectEl.find('option');
		let items = [];

		// Create the list of items
		if ($options.length > 0) {
			$options.each((i, item) => {
				let $item = $(item);
				let selected = this.$selectEl.val() ? $item.is(':selected') : false;
				let disabled = $item.attr('disabled');

				if (parseInt($item.val()) > -1 || isNaN($item.val()) || $item.val() == '') {
					items.push({
						name: this.itemNameFromSelectBox($item),
						text: escapeHtml($item.text()),
						selected: selected,
						header: disabled,
					});
				}
			});
		}

		options.items = items;

		let title = this.updateTitleFromSelect();
		if (title) {
			options.title = title;
		}
	}

	handleSelectElement(options) {
		this.$selectEl = options.$selectEl || null;

		if (this.$selectEl) {
			if (typeof (this.populateFromSelectBox) == 'function') {
				this.populateFromSelectBox(options);
			}
		}
	}

	visibleItems() {
		let visibleItems = this.changedItems;

		if (this.filtering != null) {
			visibleItems = [];
			for (let item of this.changedItems) {
				if (this.filtering.indexOf(item.name) > -1) {
					visibleItems.push(item);
				}
			}
		}

		return visibleItems;
	}

	getItems() {
		if (this.populateItemsFromDatasource) {
			this.loading = true;
			this.$items.empty();
			this.items = this.itemsFromDatasource.call(this);
		}
	}

	changeTitle(newTitle) {
		let $title = this.$el.find('.sma-js-dropdown-toggle');

		$title.html(newTitle);
	}

	formatTitle(item) {
		return item.text;
	}

	itemSelectDone() {
		return;
	}

	updateChangedItems() {
		this.changedItems = this.displayedItems;
	}

	enableAllItems() {
		this.disabledItems.length = 0;
		this.disabledItems = {};

		for (let el of this.$el.find('.sma-js-action-item.disabled')) {
			let $el = $(el);

			$el.removeClass('disabled');

			if ($el.attr('data-toggle') === 'tooltip') {
				$el.removeAttr('data-toggle');
				$el.removeAttr('title');
				$el.removeAttr('data-placement');
			}
		}
	}

	disableItem(id, reason) {
		this.disabledItems[id] = reason;
		try {
			id = id.replace(/"/g, '\\"');
		} catch (err) {
		}

		let $el = $(this.$el.find(`.sma-js-action-item[name="${id}"]`));

		$el.addClass('disabled');

		if (reason !== undefined) {
			$el.attr('data-toggle', 'tooltip')
				.attr('data-placement', 'left')
				.attr('title', reason).tooltip();
			// adding tooltip doesn't work. It should be fixed if necessary.
		}
	}

	render() {
		this._el = selectTempl({
			title: this.title,
			dropdownToggle: this.dropdownToggle,
			alignRight: this.alignRight,
			dropup: this.dropup,
			go: gettext('Go'),
			searchfor: gettext('Search for...'),
			cancel: gettext('Cancel'),
			done: gettext('Done'),
			btnClass: this.btnClass,
			doneClass: this.doneClass,
			inline: this.inline,
			cancelClass: this.cancelClass,
			drilldown: this.drilldown || false,
			noFooter: this.noFooter || false,
			createButton: this.createButton || false,
			noCancelButton: this.noCancelButton || false,
			noDoneButton: this.noDoneButton || false,
			showSelectControls: this.showSelectControls || false,
			doneButtonSize: `btn-${this.doneButtonSize || 'md'}`,
			createButtonLabel: this.createButtonLabel || gettext('Create'),
			textStyleButton: this.textStyleButton ? 'text-style-button' : '',
			editable: this.editable || false,
			closeButton: this.editable || false,
			noDropdown: this.noDropdown || false,
			strings: {
				all: gettext('All'),
				none: gettext('None'),
				selected: gettext('Selected:')
			},
			buttonSize: this.buttonSize,
			fullWidth: this.fullWidth,
			selectedCount: this.selectedCount,
		});

		this.setElement(this._el);

		this.renderContents();

		if (this.$selectEl) {
			this.$selectEl.hide();
		}

		this.updateSelectControls();
		this.updateSelectedCount();
	}

	renderContents() {
		this.renderItems();
	}

	setItems(items) {
		if (this.refreshSelectBox && this.changedItems) {
			items = this.refreshSelectBox(items);
		}

		this.items = items;
		this.changedItems = $.extend(true, [], items);
		this.updateSelectControls();
	}

	setEvents(e) {
		this.items.forEach((action) => {
			let $el;
			let actionFunc;

			if (action.name) {
				let n = action.name;
				try {
					n = n.replace(/"/g, '\\"');
				} catch (err) {
				}
				$el = this.$el.find(`a[name="${n}"]`);
			}

			if (typeof (action.action) === 'function') {
				actionFunc = action.action;
			} else if (typeof (this.globalItemAction) === 'function') {
				actionFunc = this.globalItemAction;
			}

			if ($el && actionFunc) {
				$el.click(e => {
					if (!this.actionItemWasClicked(e)) {
						actionFunc.bind(this)(action);
					}
				});
			}
		});
	}

	renderItemsFromDatasource(items) {
		this.setItems(items);
		this.renderItems();
	}

	hideDropdown(e) {
		let modalCount = $('.sma-modal:visible').length;

		if (((this.$el.closest('.sma-modal').length && modalCount > 1))
			|| this.loading
			|| $('.popover').length !== 0) {
			return false;
		}
		else {
			this.renderItems();
		}
	}

	handlePopovers() {
		for (let disabledItem in this.disabledItems) {
			let $item = $(this.$items.find(`.sma-js-action-item[name="${disabledItem}"]`));

			$item.addClass('disabled')
				.attr('data-toggle', 'tooltip')
				.attr('data-placement', 'left')
				.attr('title', this.disabledItems[disabledItem]).tooltip();
			// tooltip doesn't work for disabled class
			// workaround: add span around the div and add tooltip to it.
		}

		let itemMap = _.indexBy(this.items, 'name');

		this.$items.find('.sma-js-dropselect-editable-itemactions').each((i, target) => {
			let $item = $(target);
			let itemName = $item.prop("name");
			let item = itemMap[itemName];
			let itemActions = this.itemActions;

			if (!item) {
				return;
			}

			if (item.hideActions) {
				itemActions = _.filter(itemActions, action => {
					return !item.hideActions.includes(action.name);
				});
			}

			$item.popover({
				placement: this.popoverPlacement,
				html: true,
				content: itemActionsTempl({
					items: itemActions,
					itemName: itemName,
				}),
				template: wrapsTempl,
				trigger: 'focus',
				animation: false,
				delay: { show: 0, hide: 300 },
			});
		});
	}

	renderItems() {
		this.$items = this.$el.find('.sma-dropselect-items');
		this.$items.empty();

		let items = {
			items: this.visibleItems(),
			checkboxes: this.checkboxItems,
			itemActions: this.itemActions ? true : false,
			strings: {
				noItems: gettext('No items'),
			},
		};

		this.$items.append(itemsTempl(items));

		this.$items.find('.custom-control-indicator').each((i, el) => {
			if ($(el).hasClass('sma-js-mixed-check')) {
				$(el).siblings('.custom-control-input').prop('indeterminate', true);
			}
		});

		this.handlePopovers();

		if (this.$selectEl) {
			this.selectItemFromSelect();
		}

		if (this.items !== undefined) {
			this.setEvents();
		}
	}

	selectItemFromSelect() {
		let value = this.$selectEl.val();
		try {
			value = value.replace(/"/g, '\\"');
		} catch (err) {
		}

		let $el = this.$el.find(`.sma-js-action-item[name="${value}"]`);

		$el.addClass('active');
	}

	bindItemActions() {
		let that = this;

		$('.sma-js-dropselect-popover-item').click(function () {
			let $target = $(this);
			let actionName = $target.prop("name");
			let itemName = $target.data("item");
			let item = _.findWhere(that.items, { name: itemName });
			// Need to handle the case where itemName was an integer
			if (!item)
				item = _.findWhere(that.items, { name: itemName.toString() });
			let itemText = item.text;
			for (let action of that.itemActions) {
				if (actionName === action.name) {
					that.updateChangedItems();
					action.action.call(that, itemName, itemText);
					return false;
				}
			}
		});
	}

	get displayedItems() {
		let items = [];

		if (this.selector) {
			_.each(this.$items.children(), (item) => {
				//items are different when it's a selector
				let $item = $(item);
				let name = $item.attr('name');
				let text = _.escape($item.text());

				items.push({
					name: name,
					text: text,
					selected: $item.hasClass('active'),
					header: $item.is('h6'),
				});
			});
		} else {
			_.each(this.$items.children(), (item) => {
				let $item = $(item).find('input');
				items.push({
					name: _.escape($item.attr('name')),
					text: _.escape($item.parent().text()),
					checked: $item.is(':checked'),
					mixedCheck: $(item).find('.custom-control-indicator').hasClass('sma-js-mixed-check'),
					header: $item.is('h6'),
				});
			});
		}
		return items;
	}

	selectMixedCheckbox(e) {
		$(e.currentTarget).siblings('.sma-js-mixed-check').removeClass('sma-js-mixed-check');
	}

	unSelectAll() {
		this.$el.find('.sma-js-action-item').removeClass('active');

		for (let item of this.changedItems) {
			item.selected = false;
		}
	}

	//this let's us know if the action item popover button was clicked.
	//If it was, then we only want do open it and not do anything else.
	actionItemWasClicked(e) {
		if (e) {
			let $target = $(e.target);

			if ($target.hasClass('sma-js-dropselect-editable-itemactions') ||
				$target.parent().hasClass('sma-js-dropselect-editable-itemactions')) {
				return true;
			}
		}
		return false;
	}

	selectItem(e) {
		if (this.actionItemWasClicked(e)) {
			return false;
		}

		if (this.selector) {
			let $target = $(e.currentTarget);

			if (this.disabledItems[$target.attr('name')] !== undefined) {
				return false;
			}

			if (!this.checkboxItems && this.singleSelect) {
				this.unSelectAll();
			}

			if ($target.hasClass('active') && this.$selectEl.find('option:selected').length - 1 < this.minimumSelected) {
				return;
			}

			$target.toggleClass('active');

			$target.attr('aria-selected', function (i, attr) {
				if (attr === undefined) {
					return 'true';
				}
				return attr === 'true' ? 'false' : 'true';
			});

			this.updateChangedItems();

			if (this.$selectEl) {
				let name = $target.attr('name');
				let esc_name = name.replace(/"/g, '\\"');
				let $option = this.$selectEl.find(`option[value="${esc_name}"]`);

				if (this.singleSelect) {
					this.$selectEl.val(name);
					if (this.onSelectChange) {
						this.onSelectChange(name);
					}
				} else {
					let active = $target.hasClass('active');

					if (active) {
						$option.prop('selected', true);
					} else {
						$option.prop('selected', false);
					}
				}

				this.$selectEl.change();
				this.itemSelectDone();

				this.updateTitleFromSelect();
			}
			if (this.closeOnItemSelect || (this.$selectEl && this.singleSelect)) {
				this.handleDone();
			}
		}
		return false;
	}

	updateTitleFromSelect() {
		let title;

		if (this.changeTitleAfterSelection) {
			if (this.singleSelect) {
				let item = this.parseItem(this.$selectEl.find(':selected'));
				title = this.formatTitle(item);
			} else {
				let item_names = [];
				this.$selectEl.find(':selected').each((i, item) => {
					if ($(item).val() !== '-1') {  // Ignore the "null" option when creating the title
						item_names.push(this.parseItem($(item)).text);
					}
				});

				title = item_names.join(', ');
			}

			if (!title.length) {
				title = this.$selectEl.find('option[value=""]').text();

				if (!title.length) {
					title = gettext('Please select...');
				}
			}

			this.changeTitle(title);
			this.clearErrors();

			return title;
		}
		this.clearErrors();
	}

	clearErrors() {
		this.$el.parent().find('ul.errorlist').fadeOut(0);
		this.$el.find('.sma-js-dropdown-toggle').removeClass('error');
	}

	getPretext($item) {
		return null;
	}

	parseItem($item) {
		let selected = $item.is(':selected');
		let value = _.escape($item.val());

		return {
			name: value,
			pretext: this.getPretext(value),
			text: escapeHtml($item.text()),
			selected: selected,
		};
	}

	itemChanged(e) {
		this.updateSelectControls();

		if (this.$selectEl) {
			let $option = this.$selectEl.find('option[value="' + $(e.currentTarget).prop('name') + '"]');

			$option.prop('selected', $(e.currentTarget).is(':checked'));
		}

		this.updateSelectedCount();
	}

	selectAll(e) {
		if (e) e.preventDefault();

		for (let ci of this.changedItems) {
			ci.checked = true;
			ci.selected = true;
		}

		this.renderItems();
		this.updateSelectElement();
		this.updateSelectControls();
		this.updateTitleFromSelect();
	}

	selectNone(e) {
		if (e) e.preventDefault();

		for (let ci of this.changedItems) {
			ci.checked = false;
		}

		this.renderItems();
		this.updateSelectElement();
		this.updateSelectControls();
	}

	updateSelectElement() {
		for (let item of this.changedItems) {
			let $option = this.$selectEl.find('option[value="' + item.name + '"]');

			$option.prop('selected', item.checked);
		}
	}

	get $selectControls() {
		return this.$el.find('.sma-js-dropselect-select-controls');
	}

	get $selectControlsCount() {
		return this.$selectControls.find('.sma-js-dropselect-selected-count');
	}

	get selectedItems() {
		return _.filter(this.displayedItems, item => item.checked || false);
	}

	updateSelectControls() {
		if (!this.showSelectControls || this.$items === undefined) {
			return;
		}

		this.$selectControlsCount.text(this.selectedItems.length);
	}

	updateSelectedCount() {
		if (this.selectedCount) {
			this.$el.find('.sma-js-selected-count').text(gettext('Selected: ') + this.selectedItems.length);
		}
	}

	handleCancel() {
		this.renderItems();
		this.changedItems = $.extend(true, [], this.items);
		this.$el.removeClass('show');
		return false;
	}

	handleDone() {
		this.updateChangedItems();
		this.items = $.extend(true, [], this.changedItems);
		this.onDone(this.changedItems);
		this.$el.removeClass('show');
		return false;
	}
}

module.exports = DropSelect;
